import { useMutation, useQueryClient } from "@tanstack/react-query";

import {
	type CreateTemplateItemInput,
	createTemplateItem,
} from "@/adapters/api";

export function useCreateTemplateItem(templateId: string | undefined) {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (input: CreateTemplateItemInput) => {
			if (!templateId) throw new Error("missing template");
			return createTemplateItem(templateId, input);
		},
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: ["stage-template", templateId],
			});
		},
	});
}
